import CustomSpin from 'elements/CustomSpin'
import useFetch from 'elements/Hooks/useFetch'
import moment from 'moment'
import React from 'react'

function StatsBlock({ textColor, background, title, type }) {
  const { data = [], isLoading } = useFetch({ url: `reports/purchases/${type}/dashboard` })

  const onlyOpen = (docs = []) =>
    docs.filter((i) => !['Approved', 'Delivered', 'Confirmed', 'Issued'].includes(i.status))

  const now = moment()

  const y2d = (docs = []) => docs.filter((i) => moment(i.date).year() === now.year()).map((i) => i.date)

  return (
    <CustomSpin spinning={isLoading}>
      <div
        className={`bg-${background}-100 text-${textColor}-900 w-52 h-60 flex flex-col rounded-xl p-5 content-between justify-between text-center font-semibold`}>
        <h1 className="text-3xl h-1/3">{title}</h1>
        <div className={`"text-xl text-${textColor}-500 text-5xl h-1/3`}>{onlyOpen(data).length}</div>
        <div className={`mt-2 text-${textColor}-500`}>Open</div>
        <div className="flex justify-around content-around mt-5">
          <div>
            <div className="text-lg">{y2d(data).length}</div>
            <div className={`mt-2 text-${textColor}-500`}>Y2D</div>
          </div>
          <div>
            <div className="text-lg">{data.length}</div>
            <div className={`mt-2 text-${textColor}-500`}>L12M</div>
          </div>
        </div>
      </div>
    </CustomSpin>
  )
}

export default StatsBlock
